module.exports = __webpack_public_path__ + "img/55.2d21baeb.png";